/**
 *  Safe mode actions
 */
export const CODE_LIBRARIES_DISABLE_SAFE_MODE_REQUESTED =
  'CODE_LIBRARIES_DISABLE_SAFE_MODE_REQUESTED' as const;
export const CODE_LIBRARIES_DISABLE_SAFE_MODE_SUCCEEDED =
  'CODE_LIBRARIES_DISABLE_SAFE_MODE_SUCCEEDED' as const;
export const CODE_LIBRARIES_DISABLE_SAFE_MODE_FAILED =
  'CODE_LIBRARIES_DISABLE_SAFE_MODE_FAILED' as const;

/**
 * Component Map actions
 */
export const CODE_COMPONENT_CREATED = 'CODE_COMPONENT_CREATED' as const;
export const CODE_COMPONENT_TEMPLATE_DRAG_STARTED =
  'CODE_COMPONENT_TEMPLATE_DRAG_STARTED' as const;
export const CODE_COMPONENT_TEMPLATE_WELCOME_SHOWN =
  'CODE_COMPONENT_TEMPLATE_WELCOME_SHOWN' as const;
export const CODE_COMPONENT_UPDATED = 'CODE_COMPONENT_UPDATED' as const;

/**
 * Code Component Compilation actions
 */
export const CODE_BUILD_STARTED = 'CODE_BUILD_STARTED' as const;
export const CODE_BUILD_SUCCEEDED = 'CODE_BUILD_SUCCEEDED' as const;
export const CODE_BUILD_FAILED = 'CODE_BUILD_FAILED' as const;
export const CODE_DEPENDENCIES_INSTALLATION_FINISHED =
  'CODE_DEPENDENCIES_INSTALLATION_FINISHED' as const;

/**
 * Code Component Evaluation actions
 */
export const CODE_EVALUATED = 'CODE_EVALUATED' as const;
export const CODE_EVALUATION_FAILED = 'CODE_EVALUATION_FAILED' as const;

/**
 * Multi-state preview scenarios were defined / updated for a component.
 */
export const COMPONENT_PREVIEW_SCENARIOS_DEFINED =
  'COMPONENT_PREVIEW_SCENARIOS_DEFINED' as const;

/**
 * A single multi-state preview scenario was manually removed from a component.
 */
export const COMPONENT_PREVIEW_SCENARIO_REMOVED =
  'COMPONENT_PREVIEW_SCENARIO_REMOVED' as const;

/**
 * A single multi-state preview scenario was manually edited (label / props)
 * from the Navigator, keeping its id.
 */
export const COMPONENT_PREVIEW_SCENARIO_EDITED =
  'COMPONENT_PREVIEW_SCENARIO_EDITED' as const;

/**
 * A single multi-state preview scenario was manually created from the
 * Navigator, appended to the component's existing states.
 */
export const COMPONENT_PREVIEW_SCENARIO_CREATED =
  'COMPONENT_PREVIEW_SCENARIO_CREATED' as const;

/**
 * Code Component Reload actions
 */
export const CODE_COMPONENT_RELOADED_FROM_CRASH =
  'CODE_COMPONENT_RELOADED_FROM_CRASH' as const;

/**
 * Code Component Editor state actions
 */
export const CODE_COMPONENT_SOURCE_DRAFT_CHANGED =
  'CODE_COMPONENT_SOURCE_DRAFT_CHANGED' as const;
export const CODE_COMPONENT_SOURCE_DRAFTS_CLEARED =
  'CODE_COMPONENT_SOURCE_DRAFTS_CLEARED' as const;
export const CODE_COMPONENT_SOURCE_FILE_SAVE_REFUSED =
  'CODE_COMPONENT_SOURCE_FILE_SAVE_REFUSED' as const;

/**
 * Code Component Editor pane actions
 */
export const CODE_COMPONENT_EDITOR_PANE_SHOW =
  'CODE_COMPONENT_EDITOR_PANE_SHOW' as const;
export const CODE_COMPONENT_EDITOR_PANE_HIDE =
  'CODE_COMPONENT_EDITOR_PANE_HIDE' as const;
export const CODE_COMPONENT_EDITOR_PANE_MOVE =
  'CODE_COMPONENT_EDITOR_PANE_MOVE' as const;
export const CODE_COMPONENT_EDITOR_PANE_RESIZE =
  'CODE_COMPONENT_EDITOR_PANE_RESIZE' as const;

/**
 * Source file tree selection actions (VCC multi-file)
 */
export const CODE_COMPONENT_SOURCE_FILE_SELECTED =
  'CODE_COMPONENT_SOURCE_FILE_SELECTED' as const;
export const CODE_COMPONENT_SOURCE_TREE_COLLAPSED =
  'CODE_COMPONENT_SOURCE_TREE_COLLAPSED' as const;

/**
 * Code Component Creator actions
 */
export const CODE_COMPONENT_CREATOR_DISMISSED =
  'CODE_COMPONENT_CREATOR_DISMISSED' as const;
export const CODE_COMPONENT_CREATOR_PROMPT_SET =
  'CODE_COMPONENT_CREATOR_PROMPT_SET' as const;
export const CODE_COMPONENT_CLARIFICATION_STARTED =
  'CODE_COMPONENT_CLARIFICATION_STARTED' as const;
export const CODE_COMPONENT_CLARIFICATION_ENDED =
  'CODE_COMPONENT_CLARIFICATION_ENDED' as const;

/**
 * Visual editing beta onboarding actions
 */
export const VISUAL_EDITING_ONBOARDING_ADVANCED =
  'VISUAL_EDITING_ONBOARDING_ADVANCED' as const;
export const VISUAL_EDITING_ONBOARDING_DISMISSED =
  'VISUAL_EDITING_ONBOARDING_DISMISSED' as const;
export const VISUAL_EDITING_ONBOARDING_GENERATION_STARTED =
  'VISUAL_EDITING_ONBOARDING_GENERATION_STARTED' as const;
export const VISUAL_EDITING_ONBOARDING_STARTED =
  'VISUAL_EDITING_ONBOARDING_STARTED' as const;

/**
 * VCC Style Panel actions
 */
export const VCC_STYLE_OVERRIDES_UPDATED =
  'VCC_STYLE_OVERRIDES_UPDATED' as const;
export const VCC_STYLE_OVERRIDES_CLEARED =
  'VCC_STYLE_OVERRIDES_CLEARED' as const;
export const VCC_STYLE_OVERRIDE_GROUP_REMOVED =
  'VCC_STYLE_OVERRIDE_GROUP_REMOVED' as const;
export const VCC_STYLE_OVERRIDES_IDENTITY_DROPPED =
  'VCC_STYLE_OVERRIDES_IDENTITY_DROPPED' as const;
export const VCC_STYLE_OVERRIDES_INSTANT_APPLIED =
  'VCC_STYLE_OVERRIDES_INSTANT_APPLIED' as const;
export const VCC_STYLE_OVERRIDES_INSTANT_APPLY_PENDING =
  'VCC_STYLE_OVERRIDES_INSTANT_APPLY_PENDING' as const;
export const VCC_SELECTED_ELEMENT_REVEALED =
  'VCC_SELECTED_ELEMENT_REVEALED' as const;
export const VCC_DRAFT_STYLES_APPLIED = 'VCC_DRAFT_STYLES_APPLIED' as const;
export const VCC_PROP_CONNECTIONS_RESOLVED =
  'VCC_PROP_CONNECTIONS_RESOLVED' as const;

/**
 * VCC inline text editing actions
 */
export const VCC_TEXT_OVERRIDES_UPDATED = 'VCC_TEXT_OVERRIDES_UPDATED' as const;
export const VCC_TEXT_OVERRIDES_CLEARED = 'VCC_TEXT_OVERRIDES_CLEARED' as const;
export const VCC_TEXT_OVERRIDE_GROUP_REMOVED =
  'VCC_TEXT_OVERRIDE_GROUP_REMOVED' as const;
export const VCC_TEXT_EDIT_STARTED = 'VCC_TEXT_EDIT_STARTED' as const;
export const VCC_TEXT_EDIT_ENDED = 'VCC_TEXT_EDIT_ENDED' as const;
export const VCC_INSTANT_TEXT_APPLIED = 'VCC_INSTANT_TEXT_APPLIED' as const;
export const VCC_INSTANT_APPLY_REPORTED = 'VCC_INSTANT_APPLY_REPORTED' as const;
export const VCC_INSTANT_APPLY_ROLLED_BACK =
  'VCC_INSTANT_APPLY_ROLLED_BACK' as const;
export const VCC_APPLY_CANCELLED = 'VCC_APPLY_CANCELLED' as const;
export const VCC_APPLY_SOURCE_SNAPSHOT_TAKEN =
  'VCC_APPLY_SOURCE_SNAPSHOT_TAKEN' as const;
export const VCC_APPLY_SOURCE_SNAPSHOT_DROPPED =
  'VCC_APPLY_SOURCE_SNAPSHOT_DROPPED' as const;
export const VCC_APPLY_UNDO_TURN_ATTACHED =
  'VCC_APPLY_UNDO_TURN_ATTACHED' as const;

/**
 * Instruction source-file sync actions — keep SourceFilesStore fresh after
 * instruction CRUD, which bypasses the multiplayer diff/broadcast pipeline.
 */
export const INSTRUCTION_SOURCE_FILE_UPSERTED =
  'INSTRUCTION_SOURCE_FILE_UPSERTED' as const;

/**
 * A user edit to a VCC source file, saved from the code editor.
 *
 * Deliberately not `INSTRUCTION_SOURCE_FILE_UPSERTED`: that action is in
 * MultiplayerStore's `ignoredActions`, because instruction documents are
 * REST-owned and must not generate realtime operations. Reusing it for code
 * files would silently skip the multiplayer sync and lose the edit on reload.
 */
export const VCC_SOURCE_FILE_CONTENT_SAVED =
  'VCC_SOURCE_FILE_CONTENT_SAVED' as const;

/**
 * User-driven file operations from the source-file tree (EXT-185).
 *
 * Like the save action, these are absent from MultiplayerStore's
 * `ignoredActions` on purpose: the multiplayer diff of SourceFilesStore is what
 * produces the realtime operation, so ignoring them would make every tree edit
 * local-only. `projectFilesystem` rebuilds the sandbox from the same store, so
 * mutating it is all these need to do -- the sandbox write and the DB sync both
 * follow from it.
 */
export const VCC_SOURCE_FILE_CREATED = 'VCC_SOURCE_FILE_CREATED' as const;
export const VCC_SOURCE_FILE_RENAMED = 'VCC_SOURCE_FILE_RENAMED' as const;
export const VCC_SOURCE_FILE_DELETED = 'VCC_SOURCE_FILE_DELETED' as const;

/**
 * Files the unused-file collector retired in one pass (EXT-1962).
 *
 * Batched rather than one delete per key so that a component deletion which
 * orphans several files costs one multiplayer message and one undo step
 * instead of N of each. Deliberately absent from `ignoredActions` for the same
 * reason the user-driven operations above are.
 */
export const VCC_UNUSED_SOURCE_FILES_COLLECTED =
  'VCC_UNUSED_SOURCE_FILES_COLLECTED' as const;
export const INSTRUCTION_SOURCE_FILES_RECONCILED =
  'INSTRUCTION_SOURCE_FILES_RECONCILED' as const;
export const INSTRUCTION_SUBTREE_RENAMED =
  'INSTRUCTION_SUBTREE_RENAMED' as const;
export const INSTRUCTION_SUBTREE_DELETED =
  'INSTRUCTION_SUBTREE_DELETED' as const;

/**
 * Remote sandbox actions
 */
export const REMOTE_SANDBOX_CREATED = 'REMOTE_SANDBOX_CREATED' as const;
export const REMOTE_SANDBOX_INITIATED = 'REMOTE_SANDBOX_INITIATED' as const;
export const REMOTE_SANDBOX_SYNC_STARTED =
  'REMOTE_SANDBOX_SYNC_STARTED' as const;
export const REMOTE_SANDBOX_SYNC_COMPLETED =
  'REMOTE_SANDBOX_SYNC_COMPLETED' as const;
export const REMOTE_SANDBOX_EXPIRED = 'REMOTE_SANDBOX_EXPIRED' as const;
export const REMOTE_SANDBOX_FILES_DELETED =
  'REMOTE_SANDBOX_FILES_DELETED' as const;

/**
 * Functions preview sandbox actions
 */
export const FUNCTIONS_PREVIEW_CONNECTING =
  'FUNCTIONS_PREVIEW_CONNECTING' as const;
export const FUNCTIONS_PREVIEW_CONNECTED =
  'FUNCTIONS_PREVIEW_CONNECTED' as const;
export const FUNCTIONS_PREVIEW_FAILED = 'FUNCTIONS_PREVIEW_FAILED' as const;
export const FUNCTIONS_PREVIEW_EMPTY = 'FUNCTIONS_PREVIEW_EMPTY' as const;
export const FUNCTIONS_PREVIEW_DISABLED = 'FUNCTIONS_PREVIEW_DISABLED' as const;
export const FUNCTIONS_GENERATION_MISSING =
  'FUNCTIONS_GENERATION_MISSING' as const;

/**
 * Local dev server actions
 */
export const LOCAL_DEV_SERVER_REACHABILITY_CHANGED =
  'LOCAL_DEV_SERVER_REACHABILITY_CHANGED' as const;
export const LOCAL_DEV_LIBRARY_DISCOVERED =
  'LOCAL_DEV_LIBRARY_DISCOVERED' as const;
export const LOCAL_OVERRIDE_OPT_OUT_CHANGED =
  'LOCAL_OVERRIDE_OPT_OUT_CHANGED' as const;

/**
 * Local override actions
 */
export const LOCAL_OVERRIDE_ADDED = 'LOCAL_OVERRIDE_ADDED' as const;
export const LOCAL_OVERRIDE_REMOVED = 'LOCAL_OVERRIDE_REMOVED' as const;
